import { createSvgIcon } from '@mui/material/utils';

const CloseIcon = createSvgIcon(
    <svg viewBox="0 0 24 24">
        <path
            strokeWidth="1.5"
            d="M5.63672 5.63574L18.3646 18.3637M18.3647 5.63574L5.63682 18.3637"
        />
    </svg>,
    'Close'
);

export default CloseIcon;
